<template>
  <div class="quiz-keep">
    <div>
      <svg width="90" height="90" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="48" fill="none" stroke-width="4" stroke-dasharray="310" stroke-dashoffset="310" />
      </svg>
      <img src="@/assets/img/face.svg" alt="">
    </div>
    <p>That's great! <br>Keep going!</p>
  </div>
</template>

<script></script>